import React from "react";
import Lottie from "react-lottie";
import animationData from "./SuccessImg.json";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { Paper } from "@mui/material";

const SuccessImg = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <>
      <Grid container direction="column" alignItems="center">
        <Lottie options={defaultOptions} />
        <Typography marginTop={-3}>Success!</Typography>
      </Grid>
    </>
  );
};

export default SuccessImg;
